import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath, storagePath } from '../../constants/defaultValues';
import { storage } from '../../helpers/Firebase';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    COM_PURCHASE_ORDER,
    COM_SUPPLIER,
    COM_CATEGORY,
    COM_USER_ASSIGNED,
    COM_STATUS,
    COM_USER_FOR_ASSIGN,
    COMMUNICATION_LIST,
    COMMUNICATION_EDIT,
    COMMUNICATION_ANSWER,
    COMMUNICATION_UPLOAD_SET
} from "../actions";

import {
    ComPurchaseOrderSuccess,
    ComPurchaseOrderError,
    ComSupplierSuccess,
    ComSupplierError,
    ComCategorySuccess,
    ComCategoryError,
    ComUserAssignedSuccess,
    ComUserAssignedError,
    ComStatusSuccess,
    ComStatusError,
    ComUserForAssignSuccess,
    ComUserForAssignError,
    CommunicationListSuccess,
    CommunicationListError,
    CommunicationEditSuccess,
    CommunicationEditError,
    CommunicationAnswerSuccess,
    CommunicationAnswerError,
    CommunicationUploadSetSuccess,
    CommunicationUploadSetError
} from '../actions';

export function* watchComPurchaseOrder() {
    yield takeEvery(COM_PURCHASE_ORDER, onComPurchaseOrder);
}

export function* watchComSupplier() {
    yield takeEvery(COM_SUPPLIER, onComSupplier);
}

export function* watchComCategory() {
    yield takeEvery(COM_CATEGORY, onComCategory);
}

export function* watchComUserAssigned() {
    yield takeEvery(COM_USER_ASSIGNED, onComUserAssigned);
}

export function* watchComStatus() {
    yield takeEvery(COM_STATUS, onComStatus);
}

export function* watchComUserForAssign() {
    yield takeEvery(COM_USER_FOR_ASSIGN, onComUserForAssign);
}

export function* watchCommunicationList() {
    yield takeEvery(COMMUNICATION_LIST, onCommunicationList);
}

export function* watchCommunicationEdit() {
    yield takeEvery(COMMUNICATION_EDIT, onCommunicationEdit);
}

export function* watchCommunicationAnswer() {
    yield takeEvery(COMMUNICATION_ANSWER, onCommunicationAnswer);
}

export function* watchCommunicationUploadSet() {
    yield takeEvery(COMMUNICATION_UPLOAD_SET, onCommunicationUploadSet);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onComPurchaseOrderAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'adminCommunication/purchaseorder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onComSupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'adminCommunication/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onComCategoryAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'adminCommunication/category', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onComUserAssignedAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'adminCommunication/userassigned', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onComStatusAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'adminCommunication/status', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onComUserForAssignAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'adminCommunication/userforassign', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCommunicationListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'adminCommunication/communicationlist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onCommunicationEditAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'adminCommunication/edit', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { message: true, data: response };
};

const onCommunicationAnswerAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'adminCommunication/answer', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { message: true, data: response };
};

const onCommunicationUploadSetAsync = async (file) => {
    var storageRef = storage.ref();
    let filename = file.name;
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/answerforms/' + filename).put(file);
        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'answerforms/' })
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ message: 'success', name: filename, original: file.name, url: downloadURL });
                });
            });
    });
};

function* onComPurchaseOrder(data) {
    try {
        const response = yield call(onComPurchaseOrderAsync, data.payload);
        yield put(ComPurchaseOrderSuccess(response.data));
    } catch (error) {
        yield put(ComPurchaseOrderError(error));
    }
}

function* onComSupplier(data) {
    try {
        const response = yield call(onComSupplierAsync, data.payload);
        yield put(ComSupplierSuccess(response.data));
    } catch (error) {
        yield put(ComSupplierError(error));
    }
}

function* onComCategory(data) {
    try {
        const response = yield call(onComCategoryAsync, data.payload);
        yield put(ComCategorySuccess(response.data));
    } catch (error) {
        yield put(ComCategoryError(error));
    }
}

function* onComUserAssigned(data) {
    try {
        const response = yield call(onComUserAssignedAsync, data.payload);
        yield put(ComUserAssignedSuccess(response.data));
    } catch (error) {
        yield put(ComUserAssignedError(error));
    }
}

function* onComStatus(data) {
    try {
        const response = yield call(onComStatusAsync, data.payload);
        yield put(ComStatusSuccess(response.data));
    } catch (error) {
        yield put(ComStatusError(error));
    }
}

function* onComUserForAssign(data) {
    try {
        const response = yield call(onComUserForAssignAsync, data.payload);
        yield put(ComUserForAssignSuccess(response.data));
    } catch (error) {
        yield put(ComUserForAssignError(error));
    }
} 

function* onCommunicationList(data) {
    try {
        const response = yield call(onCommunicationListAsync, data.payload);
        yield put(CommunicationListSuccess(response.data));
    } catch (error) {
        yield put(CommunicationListError(error));
    }
}

function* onCommunicationEdit(data) {
    try {
        const response = yield call(onCommunicationEditAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(CommunicationEditSuccess(response.data));
    } catch (error) {
        yield put(CommunicationEditError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onCommunicationAnswer(data) {
    try {
        const response = yield call(onCommunicationAnswerAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(CommunicationAnswerSuccess(response.data));
    } catch (error) {
        yield put(CommunicationAnswerError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}


function* onCommunicationUploadSet({ payload }) {
    const { file } = payload;
    try {
        const response = yield call(onCommunicationUploadSetAsync, file);
        console.log("response" + JSON.stringify(response));
        if (response.message === 'success') {

            yield put(CommunicationUploadSetSuccess(response));

        }
        else {
            yield put(CommunicationUploadSetError(response));
        }
    } catch (error) {
        yield put(CommunicationUploadSetError({ name: '', original: file.name, message: error, url: '', path: '' }))
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchComPurchaseOrder),
        fork(watchComSupplier),
        fork(watchComCategory),
        fork(watchComUserAssigned),
        fork(watchComStatus),
        fork(watchComUserForAssign),
        fork(watchCommunicationList),
        fork(watchCommunicationEdit),
        fork(watchCommunicationAnswer),
        fork(watchCommunicationUploadSet)
    ]);
}